{
  "email": "hello@jimz.au",
  "linkedin": "https://www.linkedin.com/in/jimzau",
  "github": "https://github.com/jmzcray",
  "cvWord": "https://drive.google.com/open?id=0B-vmjnGH79fONEZYVFpHQVRRa00",
  "cvPdf": "https://drive.google.com/open?id=0B-vmjnGH79fOeUFKbEpnVmxpNWM",
  "profilePic": "images/profile-pic.jpg"
}
